// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"452":"4799b8a1944e85c4edc9","896":"e73da0bd86403d4dad82"}[chunkId] + ".js";
};